import { initializeApp, FirebaseApp } from 'firebase/app';
import { getAuth, Auth } from 'firebase/auth';


// When true uses local development endpoint
export const isDevelopment = (process.env.NODE_ENV === 'development');

// Hides the "Sign In", "Sign Up", and "Demo" buttons(remove after release)
const SHOW_AUTH_BUTTONS = true;  // Set to false to hide auth buttons
const SHOW_SIGNUP_BUTTON = true; // Set to false to hide sign up button

// Set to false when service is restored to hide the red outage banner.
const SHOW_OUTAGE_BANNER = false;

// Controls visibility of debug settings in the UI
const SHOW_DEBUG_SETTINGS = isDevelopment; // Set to false to hide debug settings

// Controls visibility of the onboarding test button
const SHOW_ONBOARD_TEST_BUTTON = isDevelopment; // Keep QA-only onboarding controls out of production

// Controls visibility of the generating modal test button
const SHOW_GENERATING_MODAL_TEST_BUTTON = false; // Set to true to show test button

// Controls visibility of the performance tracing telemetry
const ENABLE_PERFORMANCE_TRACING = false; // Set to false to disable performance tracing

// Temporary local QA toggle:
// false = normal behavior (iOS on iOS, Android on Android)
// true = force iOS-style install UI on Android for testing
const FORCE_IOS_MODAL_ON_ANDROID = false;

// Switch extracted-text generation to the one-pass experimental backend endpoint.
const USE_EXPERIMENTAL_EXTRACTED_TEXT_GENERATION = false;

// Force the "What's New" modal to always show (bypasses version/user checks).
// Toggle this to true when you want to test the modal, then set it back to false.
const FORCE_SHOW_WHATS_NEW = false;

// Always show the monthly-to-yearly offer after a refresh for local previewing.
// Production remains protected even if this development preview is left enabled.
const FORCE_SHOW_YEARLY_UPGRADE = false;



// Controls visibility of the Pricing button in the navbar
export const SHOW_PRICING_BUTTON = false; // Set to false to hide the pricing button

// Controls visibility of the Blog button in the navbar
export const SHOW_BLOG_BUTTON = true; // Set to false to hide the blog button

// --- Firebase Configuration ---
// Your web app's Firebase configuration (from Firebase Console)
const firebaseConfig = {
    apiKey: "AIzaSyDJfxYqK79e-Pek6jz745ZACaTk9V5E_1k",
    authDomain: "quizzify-d7220.firebaseapp.com",
    projectId: "quizzify-d7220",
    //storageBucket: "quizzify-d7220.firebasestorage.app", // unnecessary
    messagingSenderId: "989488111528",
    appId: "1:989488111528:web:3dea8d8a51140438c6079d",
    measurementId: "G-S7GXCG6LFV" // Optional: for Google Analytics
};

// Initialize Firebase
const app: FirebaseApp = initializeApp(firebaseConfig);
const auth: Auth = getAuth(app);
// --- End Firebase Configuration ---


interface Config {
    API_URL: string;
    BASE_URL: string; // Add base URL for frontend links
    SHOW_AUTH_BUTTONS: boolean;
    SHOW_SIGNUP_BUTTON: boolean;
    SHOW_OUTAGE_BANNER: boolean;
    isDevelopment: boolean;
    SHOW_DEBUG_SETTINGS: boolean;
    SHOW_ONBOARD_TEST_BUTTON: boolean;
    SHOW_GENERATING_MODAL_TEST_BUTTON: boolean;
    SHOW_PRICING_BUTTON: boolean;
    SHOW_BLOG_BUTTON: boolean;
    EMAIL_VERIFICATION_COOLDOWN_SECONDS: number;
    MAX_GENERATION_CHAR_LIMIT_FREE: number;
    MAX_GENERATION_CHAR_LIMIT_PREMIUM: number;
    MAX_QUESTIONS_FREE: number;
    MAX_QUESTIONS_PREMIUM: number;
    MAX_IMAGES_FREE: number;
    MAX_IMAGES_PREMIUM: number;
    ENABLE_PERFORMANCE_TRACING: boolean;
    FORCE_IOS_MODAL_ON_ANDROID: boolean;
    USE_EXPERIMENTAL_EXTRACTED_TEXT_GENERATION: boolean;
    FORCE_SHOW_WHATS_NEW: boolean;
    FORCE_SHOW_YEARLY_UPGRADE: boolean;
}

const development: Config = {
    API_URL: 'http://localhost:8080',
    BASE_URL: 'http://localhost:3000', // Frontend base URL for dev
    SHOW_AUTH_BUTTONS,
    SHOW_SIGNUP_BUTTON,
    SHOW_OUTAGE_BANNER,
    isDevelopment: true,
    SHOW_DEBUG_SETTINGS,
    SHOW_ONBOARD_TEST_BUTTON,
    SHOW_GENERATING_MODAL_TEST_BUTTON,
    SHOW_PRICING_BUTTON,
    SHOW_BLOG_BUTTON,
    EMAIL_VERIFICATION_COOLDOWN_SECONDS: 90,
    MAX_GENERATION_CHAR_LIMIT_FREE: 250000,
    MAX_GENERATION_CHAR_LIMIT_PREMIUM: 1000000,
    MAX_QUESTIONS_FREE: 25,
    MAX_QUESTIONS_PREMIUM: 100,
    MAX_IMAGES_FREE: 25,
    MAX_IMAGES_PREMIUM: 100,
    ENABLE_PERFORMANCE_TRACING,
    FORCE_IOS_MODAL_ON_ANDROID,
    USE_EXPERIMENTAL_EXTRACTED_TEXT_GENERATION,
    FORCE_SHOW_WHATS_NEW,
    FORCE_SHOW_YEARLY_UPGRADE,
};

const production: Config = {
    API_URL: 'https://quizzify-production.up.railway.app',
    BASE_URL: 'https://quizzify.ca', // Frontend base URL for prod
    SHOW_AUTH_BUTTONS,
    SHOW_SIGNUP_BUTTON,
    SHOW_OUTAGE_BANNER,
    isDevelopment: false,
    SHOW_DEBUG_SETTINGS,
    SHOW_ONBOARD_TEST_BUTTON,
    SHOW_GENERATING_MODAL_TEST_BUTTON,
    SHOW_PRICING_BUTTON,
    SHOW_BLOG_BUTTON,
    EMAIL_VERIFICATION_COOLDOWN_SECONDS: 90,
    MAX_GENERATION_CHAR_LIMIT_FREE: 250000,
    MAX_GENERATION_CHAR_LIMIT_PREMIUM: 1000000,
    MAX_QUESTIONS_FREE: 25,
    MAX_QUESTIONS_PREMIUM: 100,
    MAX_IMAGES_FREE: 25,
    MAX_IMAGES_PREMIUM: 100,
    ENABLE_PERFORMANCE_TRACING,
    FORCE_IOS_MODAL_ON_ANDROID,
    USE_EXPERIMENTAL_EXTRACTED_TEXT_GENERATION,
    FORCE_SHOW_WHATS_NEW,
    FORCE_SHOW_YEARLY_UPGRADE: false,
};

const config: Config = isDevelopment ? development : production;

// Export both the general config and the Firebase auth instance
export { config, auth };
